module.exports = __webpack_public_path__ + "static/media/A.e6cd66bc.png";